// extracted by mini-css-extract-plugin
export default {"wrapper":"TBZJE","createScreenshotButton":"NlCS1","scrollButton":"K0xge","screenshots":"etnQB","screenshotPreview":"CK3vq"};